import { gql } from "@apollo/client";
import { useMutation } from "@apollo/client/react";

import DefineRevitParameter from "./DefineRevitParameter.graphql";

const fragment = gql`
    fragment NewRevitParameterTemplate on IRevitParameterTemplate {
        id
        parameterID
        ... on RevitBuiltInParameterTemplate {
            bimClassID
            revitBuiltInParameterID
        }
        ... on RevitSharedParameterTemplate {
            revitSharedParameterDefinition {
                group
                instance
                modifiable
                type
                visible
            }
        }
    }
`;

export default function useDefineRevitParameter(parameterID: string, bimClassID: string, revitParameterDefinition) {
    return useMutation(
        gql(DefineRevitParameter),
        {
            update(cache, { data }) {
                cache.modify(
                    {
                        fields: {
                            revitParameterTemplates(existing = []) {
                                return [
                                    ...existing,
                                    cache.writeFragment(
                                        {
                                            data: data.defineRevitParameter,
                                            fragment,
                                        }
                                    ),
                                ];
                            },
                        },
                    }
                );
            },
            variables: {
                parameterID,
                bimClassID,
                ...(
                    revitParameterDefinition.id
                        ? { revitBuiltInParameterID: revitParameterDefinition.id }
                        : { revitSharedParameterDefinition: revitParameterDefinition }
                ),
            },
        },
    );
}
